module.exports = "<tags-input add-from-autocomplete-only=true display-property=pdf key-property=id ng-disabled=$ctrl.readOnly ng-model=$ctrl.documentTags placeholder=\"{{ 'Add an archived document...' | translate }}\" replace-spaces-with-dashes=false> <auto-complete source=$ctrl.archivedDocumentSearch($query) min-length=1></auto-complete> </tags-input> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/archiveddocumentlist/partial.html
// module id = 528
// module chunks = 0